import { render, staticRenderFns } from "./PdvVendas.vue?vue&type=template&id=cfa7ed06&scoped=true&"
import script from "./PdvVendas.vue?vue&type=script&setup=true&lang=js&"
export * from "./PdvVendas.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa7ed06",
  null
  
)

export default component.exports